/**
 * Derived-initials helper — the SINGLE source of truth for turning a
 * person's name/email into the two-letter avatar/menu chip text. Hoisted
 * verbatim from ``features/sales/components/salesPeople.tsx`` so every
 * surface (sales ``PersonAvatar``, console user menu) derives initials
 * identically instead of carrying drifting copies.
 */

/** Derive up-to-two uppercase initials from a name, falling back to email. */
export function initialsOf(
  name?: string | null,
  email?: string | null,
): string {
  const source = name?.trim() || email?.trim() || "";
  if (!source) return "?";
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
  return source.slice(0, 2).toUpperCase();
}
